import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { Home, ShoppingBag, Mail, ArrowRight } from "lucide-react";
import logo from "@/assets/Weautomate logo-01.png";

const LINKS = [
  { to: "/",            label: "Home",        icon: Home },
  { to: "/marketplace", label: "Marketplace", icon: ShoppingBag },
  { to: "/contact",     label: "Contact",     icon: Mail },
];

export default function NotFound() {
  return (
    <div className="min-h-screen flex flex-col items-center justify-center px-6 text-center relative overflow-hidden">
      <div className="pointer-events-none absolute inset-0">
        <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[700px] h-[400px] rounded-full bg-gradient-to-r from-[#9D4CDD] to-[#FF3366] opacity-[0.06] blur-3xl" />
      </div>

      <motion.div
        initial={{ opacity: 0, y: 32 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.8, ease: [0.16, 1, 0.3, 1] }}
        className="relative z-10"
      >
        <img src={logo} alt="WeAutomate" className="h-10 w-auto mx-auto mb-10" />

        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 0.15 }}
          className="font-display text-[120px] lg:text-[180px] leading-none gradient-text select-none"
        >
          404
        </motion.div>

        <motion.h1
          initial={{ opacity: 0, y: 16 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6, delay: 0.25, ease: [0.16, 1, 0.3, 1] }}
          className="font-display text-3xl lg:text-5xl tracking-tighter mt-4"
        >
          This page wandered off.
        </motion.h1>

        <motion.p
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 0.4 }}
          className="mt-4 text-white/50 max-w-sm mx-auto"
        >
          It happens to the best of them. Here are some doors back in.
        </motion.p>

        <motion.div
          initial={{ opacity: 0, y: 12 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6, delay: 0.5 }}
          className="mt-10 flex flex-wrap justify-center gap-3"
        >
          {LINKS.map(({ to, label, icon: Icon }) => (
            <Link key={to} to={to}
                  className="flex items-center gap-2.5 px-5 py-2.5 rounded-full border border-white/15 hover:border-[#9D4CDD] hover:text-white text-white/70 transition-colors text-sm">
              <Icon className="w-4 h-4" /> {label}
            </Link>
          ))}
        </motion.div>

        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 0.7 }}
          className="mt-10"
        >
          <Link to="/" className="inline-flex items-center gap-2 text-sm text-accent hover:text-white transition-colors">
            Take me home <ArrowRight className="w-3.5 h-3.5" />
          </Link>
        </motion.div>
      </motion.div>
    </div>
  );
}
